/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { injectable } from 'inversify';
import { TAgent, getAgent } from './agent';
import { HeaderProps, SignInProps } from './plugins';

const is = require('is_js');

@injectable()
export class SignInPageService {
  public agent: TAgent;
  private readonly loginRestAPI: string;
  private readonly headers: HeaderProps;
  private readonly signerPK: string;
  private userEmail: string = '';
  static displayName = 'SignInPageService';
  constructor(props: any = {}) {
    console.log(`bla bla loginRestAPI:`, props?.loginRestAPI);
    this.agent = getAgent();
    this.loginRestAPI = props?.loginRestAPI;
    this.headers = props?.headers;
    this.signerPK = props.signerPK;
  }

  public setUserEmail(email: string) {
    this.userEmail = email;
  }

  public getUserEmail() {
    return this.userEmail;
  }

  public async signInUser(args: SignInProps) {
    let _args = {
      ...args,
      apiURL: this.loginRestAPI,
      headers: this.headers,
    };
    const agent = getAgent();
    return agent.signInUser(_args);
  }

  public async sendOTP(args: { email: string }) {
    let _args = {
      ...args,
      apiURL: this.loginRestAPI,
      headers: this.headers,
    };
    const agent = getAgent();
    return agent.sendOTP(_args);
  }

  public async getSignInType(args: { email: string }) {
    let _args = {
      ...args,
      apiURL: this.loginRestAPI,
      headers: this.headers,
    };
    const agent = getAgent();
    return agent.getSignInType(_args);
  }

  public async getAccessToken(args: { role: string; jwtToken: string }) {
    let _args = {
      ...args,
      apiURL: this.loginRestAPI,
      headers: this.headers,
    };
    const agent = getAgent();
    return agent.getAccessToken(_args);
  }

  public getStaticPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();
    compProps = agent.getStaticPageContentSync({});
    if (compProps) {
      content = { ...content, ...compProps };
    }
    return content;
  }

  public async getPageContent() {
    let content: any = {};
    let compProps: any = null;

    const agent = getAgent();
    const { token, decoded } = await agent?.parseAndDecodeToken({
      signerPK: this.signerPK,
    });
    content = {
      ...content,
      initialData: {
        email: decoded?.email,
      },
      token: token,
    };
    return content;
  }
}
